import { Component, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { PreguntasService } from '../_services/preguntas.service';

import { NgForm } from '@angular/forms';

import { GlobalEventsManager } from "../_services/globaleventsmanager.service";
import { NormasService } from '../_services/normas.service';
import { EmpresasService } from '../_services/empresas.service';

import { Empresa } from '../_models/empresa.model';

import { AppSettings } from '../_models/settings.models'


declare var jQuery: any;

@Component({
    selector: 'empresa',
    templateUrl: 'empresa.template.html'
})
export class EmpresaComponent implements OnInit, OnDestroy, AfterViewInit {

  subscription: Subscription;

  empresa: Empresa;
  insertonueva: boolean = false;

  mostrarmodalimagenes: boolean = false;

  nuevazona: string = "";

  apikeytoken: string = AppSettings.API_KEYTOKEN;
  currentUserToken: string = localStorage.getItem('currentUserToken');

  listaprovincias: any = [];
  listamunicipios: any = [];
  listacnae: any = [];
  listasubcnae: any = [];
  listaactividadesempresariales: any = [];
  listainterlocutoresinicie: any = [];
  listazonas: any = [];

  id_empresa: number = 0;

  iconocerrar: string = 'fa fa-times';

  @ViewChild('formreport') public formreport:ElementRef;

  constructor(private seguridad: SeguridadService,
      private router: Router,
      private normasService: NormasService,
      private empresasService: EmpresasService,
      private globalEventsManager: GlobalEventsManager,
      private activatedRoute: ActivatedRoute) {

      //super(empresasService);

  }

  ngOnInit() {

    this.empresa = new Empresa();

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode) => {
        if (mode !== null) {
            if (!mode) {
                this.router.navigate(['login']);
            }
        }
    });

    this.globalEventsManager.menuExtendido(true);


    let breadcrumb: any = [
      {
        'path':'/empresas',
        'name': 'Administración de empresas'
      },
      {
        'path':'#',
        'name': 'Empresa'
      }];

    this.globalEventsManager.setNombrePagina(breadcrumb);

    let _id_empresa = this.activatedRoute.snapshot.params["id_empresa"];
    if (_id_empresa && _id_empresa != 0 && _id_empresa != 'nuevo' ){
      this.getEmpresa(_id_empresa);
      this.id_empresa = _id_empresa;
    }else{
      this.nuevaEmpresa();
      this.id_empresa = 0;
    }

    this.getListaInterlocutoresInicie();


  }

  ngAfterViewInit() {

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  nuevaEmpresa(){
    this.insertonueva = true;
    this.empresa.nfiscal = "Nueva Empresa";
    this.getListaProvincias();
    this.getListaActividadesEmpresariales();
  }

  getEmpresa(id_empresa: number){

    this.empresasService.getEmpresa(id_empresa).subscribe(
        data => {
          if (data){
            this.updateEmpresa(data.json().empresa);
          }
        }
    );
  }

  updateEmpresa(data){

    this.empresa.cif = data.cif;
    this.empresa.codpostal =data.codpostal;
    this.empresa.direccion = data.direccion;
    this.empresa.email = data.email;
    this.empresa.id_actividadempresarial =data.id_actividad;
    this.empresa.id_cnae =data.id_cnae;
    this.empresa.id_empresa =data.id_empresa;
    this.empresa.id_interlocutorinicie =data.id_interlocutorinicie;
    this.empresa.id_municipio =data.id_municipio;
    this.empresa.id_provincia =data.id_provincia;
    this.empresa.id_subcnae =data.id_subcnae;
    this.empresa.nfiscal = data.nfiscal;
    this.empresa.representante = data.representante;
    this.empresa.representantedni = data.representantedni;
    this.empresa.telefono = data.telefono;
    this.empresa.logo = data.img;
    this.empresa.foto = "";
    this.empresa.interlocutor = data.interlocutor;
    this.empresa.interlocutoremail = data.interlocutoremail;
    this.empresa.interlocutortelefono = data.interlocutortelefono;

    this.id_empresa = this.empresa.id_empresa;

    this.getListaProvincias();
    this.getListaMunicipios(this.empresa.id_provincia);

    this.getListaActividadesEmpresariales();
    this.getListaCnae(this.empresa.id_actividadempresarial);
    this.getListaSubCnae(this.empresa.id_cnae);

    this.getListaZonas(this.empresa.id_empresa);

  }

  getListaZonas(id_empresa: number){

    let params = {
      id_empresa: id_empresa,
      action: "listagetZonas"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listazonas = data.json().lista;
          }
        }
    );

  }

  getListaProvincias(){

    let params = {
      action: "ListagetProvincias"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listaprovincias = data.json().lista;
          }
        }
    );

  }

  getListaMunicipios(id_provincia: number){

    let params = {
      action: "ListagetMunicipios",
      id_provincia: id_provincia
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listamunicipios = data.json().lista;
          }
        }
    );

  }

  getListaCnae(id_cnae: number){

    let params = {
      action: "ListagetCNAE",
      id_cnae: id_cnae
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listacnae = data.json().lista;
          }
        }
    );

  }

  getListaSubCnae(id_cnae: number){

    let params = {
      action: "ListagetSUBCNAE",
      id_cnae: id_cnae
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listasubcnae = data.json().lista;
          }
        }
    );

  }

  getListaActividadesEmpresariales(){

    let params = {
      action: "ListagetActividadesEmpresariales"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listaactividadesempresariales = data.json().lista;
          }
        }
    );

  }

  getListaInterlocutoresInicie(){

    let params = {
      action: "ListagetInterlocutoresEmpresas"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listainterlocutoresinicie = data.json().lista;
          }
        }
    );

  }


  fileChange(event) {

    let fileList: FileList = event.target.files;

    if(fileList.length > 0) {

        let file: File = fileList[0];
        let formData:FormData = new FormData();

        formData.append('logotipo', file, file.name);
        formData.append('id_empresa', String(this.empresa.id_empresa));

        this.empresasService.setLogo(formData).subscribe(
            data => {
              if (data){
                console.log(data);
              }
            }
        );

    }

    /*
    fileChange(event) {
        let fileList: FileList = event.target.files;
        if(fileList.length > 0) {
            let file: File = fileList[0];
            let formData:FormData = new FormData();
            formData.append('uploadFile', file, file.name);
            let headers = new Headers();
            headers.append('Content-Type', 'multipart/form-data');
            headers.append('Accept', 'application/json');
            let options = new RequestOptions({ headers: headers });
            this.http.post(`${this.apiEndPoint}`, formData, options)
                .map(res => res.json())
                .catch(error => Observable.throw(error))
                .subscribe(
                    data => console.log('success'),
                    error => console.log(error)
                )
        }
    }*/
  }

  guardar(formulario: NgForm, event: Event){
    this.onSubmit(formulario,event);
  }

  onSubmit(formulario: NgForm, event: Event=null){
    event.preventDefault;

    let empresa: any;

    empresa = {
      cif : this.empresa.cif,
      codpostal: this.empresa.codpostal,
      direccion : this.empresa.direccion,
      email : this.empresa.email,
      id_actividad: this.empresa.id_actividadempresarial,
      id_cnae: this.empresa.id_cnae,
      id_empresa: this.empresa.id_empresa,
      id_interlocutorinicie: this.empresa.id_interlocutorinicie,
      id_municipio: this.empresa.id_municipio,
      id_provincia: this.empresa.id_provincia,
      id_subcnae: this.empresa.id_subcnae,
      nfiscal : this.empresa.nfiscal,
      representante : this.empresa.representante,
      representantedni : this.empresa.representantedni,
      telefono : this.empresa.telefono,
      logo : this.empresa.logo,
      foto : this.empresa.foto,
      interlocutor : this.empresa.interlocutor,
      interlocutoremail : this.empresa.interlocutoremail,
      interlocutortelefono : this.empresa.interlocutortelefono
    };


    this.empresasService.setEmpresa(empresa).subscribe(
      data => {
        if (data){

          let al: any = {
            "texto" : "Empresa guardada",
            "mostrar": true
          };
          this.globalEventsManager.setAlert(al);

          this.updateEmpresa(data.json().empresa);
          if (this.insertonueva){
            this.router.navigate(['empresas',this.empresa.id_empresa]);
          }
        }
      }
    );
  }

  onChangeModal(event){
    this.mostrarmodalimagenes = false;
    this.getEmpresa(this.id_empresa);

  }

  verSubida(){
    this.mostrarmodalimagenes = true;
  }

  anadirZona(){
    this.empresasService.nuevaZona(this.nuevazona, this.empresa.id_empresa).subscribe(
        data => {
          if (data){
            this.nuevazona = "";
            this.getListaZonas(this.empresa.id_empresa);
          }
        }
    );
  }

  eliminarZona(zona: any){
    this.empresasService.eliminarZona(zona.id_zona, this.empresa.id_empresa).subscribe(
        data => {
          if (data){
            this.nuevazona = "";
            this.getListaZonas(this.empresa.id_empresa);
          }
        }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/empresas/empresa.component.ts